
export const Details={
    title:"Call For Papers",
    content:"The conference's goal is to gather scholars from all over the world to present advances in the relevant fields and to foster an environment conducive to exchanging ideas and information. This conference will also provide an ideal environment to develop new collaborations and meet experts on the fundamentals, applications, and products in the fields of Noise and Vibration control. Technical papers are solicited on the topics pertaining to the scope of the conference will include, but are not limited to, the following:"
}

export const AboutId={
    title:"About Industrial Design Department",
    content:"Industrial Design involves designing of products of daily life such as mobile phones, cars, home interiors, furniture, home decor, packaging and branding, and so on in such a way so that it makes the modern human life easy and more pleasurable. The field also includes designing of workplaces and tools/equipment in industries to make them safer and more user friendly. The field also includes the designing of user interfaces and digital arts such as websites, brand logos etc. The present-day academic activities of Industrial Design are very broad with this due reason. The Industrial Design department at NIT Rourkela has specialized faculties in all important areas of industrial design such as product design,ergonomics & UX/UI."
}


//Home Page/ImportantComponent
export const importantDatesData=[
    {
        title:"Call for Papers",
        subtitle:"",
        duedate:"20th May, 2024"
    },
    {
        title:"Full Paper Submission Deadline ",
        subtitle:"",
        duedate:"20th June, 2024"
    },
    {
        title:"Paper Acceptance Notification",
        subtitle:"",
        duedate:"30th June, 2024"
    },
    {
        title:"Camera-Ready Paper Submission",
        subtitle:"",
        duedate:"10th July, 2024"
    },
    {
        title:"Final Registration Deadline",
        subtitle:"",
        duedate:"10th August, 2024"
    },
    {
        title:"Conference Date (Hybrid Mode)",
        subtitle:"",
        duedate:"16th-17th August, 2024"
    
    }
]

//Home Page/Important Announcements Component

export const Topics=[
   
    {
        content:"Acoustics Modelling",
    },
    {
        content:"Underwater Acoustics",
       
    },
    {
        content:"Acoustics Metamaterial",
    },
    {
        content:"Noise Control",
    },
    {
        content:"Noise Barrier",
    },
    {
        content:"Acoustic sensors and transducers",
    }
    ,{
        content:"Experimental techniques and measurements in the field of Sound & vibration",
    },
    {
        content:"Artificial Intelligence and Machine Learning"
    },{
        content:"Rotor Dynamics",
    }
]


//Home Page/About Ipdims Component
export const About={
    title:"About DS-NVC 2024",
    content:"The main objective of the conference is to bring the academician,researcher, and industry persons under an umbrella to exchange their knowledge and to enhance collaboration. Controlling noise and vibration is crucial in various industries and applications, including manufacturing, construction, transportation, and residential environments. Effective design strategies for noise and vibration control are indispensable in various industries and applications,ranging from automotive and aerospace to architectural and industrial settings; and involve a combination of engineering principles, material selection, and structural design. Noise control solutions can be passive or active. This conference is aimed at bringing energy, power electronics, and control engineers into a single platform by which they can be able to exchange their ideas."
}

//Home Page/About Host Component
export const aboutNIT={
    title:"About NIT Rourkela",
    content:"NIT Rourkela is an institution of national importance with a reputation for excellence in research, consultancy, and education at the undergraduate, postgraduate, and doctoral levels. It is passionately committed to making our country a world leader in technology and science and to inculcate this commitment among all its students. Our target is to be known worldwide for our academic standards and to be counted among the best technological institutes in India in terms of innovation, entrepreneurship, and intellectual wealth creation."
}

export const footerData=[
    {
        title:"Venue",
        content:[
            "Industrial Design Department,",
            "National Institute Of Technology, Rourkela,",
            "Pin code: 769008,",
            "Rourkela , Odisha",
        ]
    },
    {
        title:"Contact Us ",
        content:[
            "Phone: 0661 246 2856",
            "Email: 2024nationalconvention@gmail.com"
        ]
    },
    {
        title:"Program Convenor",
        content:[
            "Prof. Mohit Lal",
            "Department of Industrial Design",
            "National Institute of Technology, Rourkela"
        ]
    },
    {
        title:"Principal Coordinator",
        content:[
            "Prof. Dibya Prakash Jena",
            "Department of Industrial Design",
            "National Institute of Technology, Rourkela"
        ]
    }

]


// Registration/ FeeDetails Component
export const registrationFeeDetails={
    
    headRow:{
        Category:"INDIAN(INR)",
        EarlyBird:"Early Bird",
        LateReg:"Late Registration"
    },
    content:[
        {
        Category:"Student",
        EarlyBird:"Rs.3500",
        Late:"Rs.5000"
    },
    {
        Category:"Academicia",
        EarlyBird:"Rs.5000 ",
        Late:"Rs.7000 "
    },

    {
        Category:"Industry delegates",
        EarlyBird:"Rs.7000 ",
        Late:"Rs.9000"
    },
    {
        Category:"Accompanying person",
        EarlyBird:"Rs.3000 ",
        Late: "Rs.4000"
    }
    ]  
}
export const RegistrationForForeigners={
    
    headRow:{
        Category:"FOREIGN (USD)",
        EarlyBird:"Early Bird",
        LateReg:"Late Registration"
    },
    content:[
        {
        Category:"Student",
        EarlyBird:"150$",
        Late:"200$"
    },
    {
        Category:"Academicia",
        EarlyBird:"200$",
        Late:"250$"
    },

    {
        Category:"Industrial Delegates",
        EarlyBird:"250$",
        Late:"300$"
    },
    {
        Category:"Accompanying person",
        EarlyBird:"100$",
        Late: "150$"
    }
    ]  
}


// Registration/Note Component
export const noteData=[
    "☑️ Each paper should be registered either by the corresponding author or any of the coauthor of the paper to publish in the conference proceedings.",
    "☑️ Payment towards registration should be made through online transfer or Demand Draft.",
    "☑️ After the payment of Registration fees, authors are requested to fill the online registration form in order to complete the registration.",
    "☑️ Registration fee covers the full participation of conference keynote speaks, presentations during all technical sessions and participation certificate.",
    "☑️ Registration fee includes institute overhead charges and GST as per actual. There are no additional charges for paper publication.",
    // "☑️ Participants under physical mode are entitled for conference kit, local tour, refreshments, working lunch, breakfast and gala dinner.",
]


// AuthorGuidelines/Guidelines Component

export const guidelinesPage=
{
    submissionGuidelines:[
        "Prospective authors from India and Abroad are invited to submit manuscripts reporting original, unpublished research and recent developments in the topics related to the conference.",
    "Submissions must include title, abstract, author affiliation with the email address and keywords as per template which is available in the website.",
    "The paper should not contain page numbers or any special headers or footers.",
    "Regular papers should present novel perspectives within the general scope of the conference.",
    "Short papers (Work-in-Progress) are an opportunity to present preliminary or interim results.",
    "The paper length should be in 6-8 pages Literature reviews/survey papers will only be considered if they present a new perspective or benefit the field.",
    "To be published, such papers must go beyond a review of the literature to define the field in a new way or highlight exciting new technologies or areas of research.",
    "All submitted papers will be subjected to a “similarity test” by Turnitin Software.",
    "Papers achieving a minimal similarity index i.e. less than 15% will be examined, and those are deemed unacceptable will be rejected /withdrawn without a formal review.",
    ],
    policyOnPlagiarism:[
       " Authors are requested to kindly refrain from plagiarism in any form. Authors should submit their original and unpublished research work not under consideration for publication everywhere.",
       "Manuscript found to be plagiarised during any stage of review shall be rejected.",
"As per the copyright transfer agreement, authors are deemed to be individually or collectively responsible for the content of the manuscript published by them."
    ]
}

